import React from "react";
import { Link } from '@ambiguous/link';
export default function MenuCustom({ items, separator }) {
    return (React.createElement("div", { className: `ltg-menu-custom ${separator == 'line' ? 'ltg-menu-custom--line' : ''}` }, items && items.map((item) => {
        var _a;
        const { url, alt } = item.image || {};
        if (item.url) {
            return (React.createElement(Link, { className: "ltg-menu-custom-item", href: item.url, target: ((_a = item === null || item === void 0 ? void 0 : item.url__props) === null || _a === void 0 ? void 0 : _a.blank) ? '_blank' : null, key: item._id },
                url && React.createElement("div", null,
                    React.createElement("img", { className: "ltg-menu-custom-img", src: url, alt: alt || item.title })),
                React.createElement("div", { dangerouslySetInnerHTML: { __html: item.title } })));
        }
        return (React.createElement("span", { key: item._id, className: "ltg-menu-custom-item" },
            url && React.createElement("div", null,
                React.createElement("img", { className: "ltg-menu-custom-img", src: url, alt: alt || item.title })),
            React.createElement("div", { dangerouslySetInnerHTML: { __html: item.title } })));
    })));
}
